// Carrusel «Resultados desde la primera sesión» (sections/skindion-results-carousel.liquid). Script clásico: la lógica
// pura vive en window.SkindionResults para probarla en Node (tools/promo-results.test.mjs).
// Solo se reproduce el clip visible; los demás cargan al acercarse. Con prefers-reduced-motion queda el poster.
(() => {
  const logic = (window.SkindionResults = window.SkindionResults || {
    /** Ancho de la barra (0-1): lo ya recorrido más lo visible, sobre el total. */
    progress({ scrollLeft, clientWidth, scrollWidth }) {
      if (!scrollWidth) return 0;
      return Math.min(1, Math.max(0, (scrollLeft + clientWidth) / scrollWidth));
    },
    /** ¿Se reproduce este clip? Solo si se ve en su mayor parte y no se pidió menos movimiento. */
    shouldPlay(visibleRatio, reducedMotion) {
      return !reducedMotion && visibleRatio >= 0.6;
    },
    /** Flechas: anterior inactiva al inicio, siguiente al final (1 px de tolerancia por redondeo). */
    arrows({ scrollLeft, clientWidth, scrollWidth }) {
      return { prev: scrollLeft <= 1, next: scrollLeft + clientWidth >= scrollWidth - 1 };
    },
  });

  if (typeof customElements === 'undefined' || customElements.get('skindion-results')) return;

  class SkindionResults extends HTMLElement {
    #abort = new AbortController();
    #observers = [];

    connectedCallback() {
      const { signal } = this.#abort;
      const track = this.querySelector('[data-track]');
      const bar = this.querySelector('[data-bar]');
      if (!track) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const videos = [...track.querySelectorAll('video')];

      const sync = () => {
        if (bar) bar.style.width = `${logic.progress(track) * 100}%`;
        const state = logic.arrows(track);
        this.querySelectorAll('[data-dir]').forEach((b) => (b.disabled = Number(b.dataset.dir) < 0 ? state.prev : state.next));
      };
      track.addEventListener('scroll', sync, { passive: true, signal });
      window.addEventListener('resize', sync, { passive: true, signal });
      sync();

      // Flechas (escritorio): una tarjeta por clic.
      const step = () => (track.querySelector('[data-card]')?.getBoundingClientRect().width ?? track.clientWidth) + 16;
      this.querySelectorAll('[data-dir]').forEach((b) =>
        b.addEventListener('click', () => track.scrollBy({ left: Number(b.dataset.dir) * step(), behavior: reduced.matches ? 'auto' : 'smooth' }), { signal })
      );

      // Arrastre con el mouse en escritorio (el dedo ya desliza de forma nativa).
      let drag = null;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        drag = { x: e.clientX, left: track.scrollLeft };
        track.classList.add('is-dragging');
      }, { signal });
      window.addEventListener('pointermove', (e) => {
        if (drag) track.scrollLeft = drag.left - (e.clientX - drag.x);
      }, { signal });
      window.addEventListener('pointerup', () => {
        if (!drag) return;
        drag = null;
        track.classList.remove('is-dragging');
      }, { signal });

      // Carga diferida: cerca del viewport el clip pasa a preload="auto".
      const near = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const video = entry.target;
          if (video.preload !== 'auto') video.preload = 'auto';
          near.unobserve(video);
        }
      }, { root: track, rootMargin: '0px 60% 0px 60%' });

      // Reproducción: solo el clip visible.
      const visible = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (logic.shouldPlay(entry.intersectionRatio, reduced.matches)) video.play().catch(() => {});
          else video.pause();
        }
      }, { threshold: [0, 0.6, 1] });

      for (const video of videos) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        visible.observe(video);
      }

      // `near` mide contra el carrusel, no contra la pantalla: arrancado al cargar, descargaba los clips aunque la
      // sección estuviera muy abajo. Empieza cuando la sección se acerca al viewport.
      const seccion = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        seccion.disconnect();
        videos.forEach((video) => near.observe(video));
      }, { rootMargin: '400px 0px' });
      seccion.observe(this);
      this.#observers = [seccion, near, visible];
      reduced.addEventListener?.('change', () => { if (reduced.matches) videos.forEach((v) => v.pause()); }, { signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#observers.forEach((o) => o.disconnect());
    }
  }

  customElements.define('skindion-results', SkindionResults);
})();
